import { Container, Flex, FloraButton } from '@grupoboticario/flora-react';
import { ArrowsCircleIcon } from '@grupoboticario/flora-react-icons';
import { ResponsiveFloraTypography } from 'ui/components/primitives/ResponsiveFloraTypography';

import { ReloadPageProps } from './ReloadPage.d';
import Styles from './ReloadPage.styles';

export const ReloadPage = ({
  title = 'Tivemos um problema',
  subtitle = 'Por favor, tente novamente',
}: ReloadPageProps) => {
  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <Styles.Wrapper>
      <Container size="medium">
        <Styles.Content gap="$2" direction="column" align="center">
          <ArrowsCircleIcon color="$backgroundAltPrimary" size={60} />
          <ResponsiveFloraTypography
            color="$backgroundAltPrimary"
            fontWeight="bold"
            fontSize="subtitle"
          >
            {title}
          </ResponsiveFloraTypography>
          <ResponsiveFloraTypography color="$backgroundAltSecondary" fontSize="bodyLargeShort">
            {subtitle}
          </ResponsiveFloraTypography>
        </Styles.Content>
        <Flex direction="column">
          <FloraButton
            onClick={refreshPage}
            autotagging-flora="on"
            data-flora="button"
            data-flora-text="tentar-novamente"
          >
            <ResponsiveFloraTypography fontSize="bodyLargeStandard">
              Tentar novamente
            </ResponsiveFloraTypography>
          </FloraButton>
        </Flex>
      </Container>
    </Styles.Wrapper>
  );
};
